import { FC } from "react";
import { IOrderItem } from "../../../model/IOrder";
import Modal from "../../common/Modal";
import { DetailRow } from "./DetailPanel";

/**
 * What an order item recorded about the part itself.
 *
 * Opened from the Product ID in the items table. The description is the long
 * free-text blob the feed supplied, so it goes in a <pre> - it arrives with
 * its own line breaks and spacing, and reflowing it loses the only structure
 * it has.
 */
const OrderItemModal: FC<{ item: IOrderItem, onClose: () => void }> = ({ item, onClose }) => (
  <Modal
    isShown
    title={`Product ${item.pid || ''}`}
    style={{ maxWidth: '820px' }}
    onClose={onClose}
  >
    <div className="flex flex-col gap-4">
      <div>
        {/* Zero is a distance, not a blank - only a missing value is "—". */}
        <DetailRow
          label="Distance"
          value={item.distance === null || item.distance === undefined
            ? null
            : `${item.distance} mi`}
        />
        <DetailRow label="Location" value={item.location} />
        {/* order_items.supplier_id - the Supplier ID column in the table above. */}
        <DetailRow label="Tag #" value={item.supplierId} />
      </div>

      <div>
        <div className="text-text_pale mb-1">Full Description</div>
        {item.fullDescription
          ? (
            <pre className="
              rounded-md ring-1 ring-inset ring-gray-200 bg-white px-3 py-2
              max-h-[50vh] overflow-auto stylledScroll
              whitespace-pre-wrap break-words font-mono text-sm
            ">
              {item.fullDescription}
            </pre>
          )
          : <div className="text-text_pale">No description recorded</div>
        }
      </div>
    </div>
  </Modal>
);

export default OrderItemModal;
